
$('.pdp-product-info-reviews-carousel').slick({
    slidesToShow: 1.2,
    arrows: false,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1
        }
      }
    ]
});

$('.pdp-product-info-reviews-carousel').on('click', '.carousel-custom-next', function() {
  $('.pdp-product-info-reviews-carousel').slick('slickNext')
});

$('.pdp-product-info-reviews-carousel').on('click', '.carousel-custom-prev', function() {
  $('.pdp-product-info-reviews-carousel').slick('slickPrev')
});

/* Observer for sticky ATC */
const targetElement = document.querySelector('.product-form__buttons');
const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0 // Trigger when the target enters or exits the viewport
};
const callback = function(entries, observer) {
  entries.forEach(entry => {
    if (!entry.isIntersecting && entry.boundingClientRect.y < 0) {
      document.body.classList.add('sticky-atc-active');
    } else {
      document.body.classList.remove('sticky-atc-active');
    }
  });
};
const observer = new IntersectionObserver(callback, options);
observer.observe(targetElement);